<cipo-dialog-header [title]="moduleParameter.moduleName" fullScreen="never" [closeResult]="undefined" />
<mat-dialog-content>
    <div class="p-t" fxLayout fxLayoutAlign="space-between center" fxLayoutGap="16px">
        <mat-form-field appearance="outline" fxFlex>
            <mat-label>{{ "moduleParameter.moduleValue" | translate }}</mat-label>
            <input matInput disabled [value]="moduleParameter.moduleValue" type="number" />
        </mat-form-field>
        <mat-form-field appearance="outline" fxFlex>
            <mat-label>
                {{ "moduleParameter.value" | translate: { contractModuleName: contractModuleName() } }}
            </mat-label>
            <input matInput [formControl]="valueControl" type="number" />
        </mat-form-field>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button [mat-dialog-close]="undefined">{{ "general.close" | translate }}</button>
    <button mat-raised-button color="primary" (click)="onSave()">{{ "general.save" | translate }}</button>
</mat-dialog-actions>
